import CloseIcon from "./CloseIcon";
import MinimizeIcon from "./MinimizeIcon";
import BubbleIcon from "./BubbleIcon";
import PersonIcon from "./PersonIcon";
import RobotIcon from "./RobotIcon";
import HourGlassIcon from "./HourGlassIcon";
import withIconButton from "./withIconButton";
import ThumbsUpIcon from "./ThumbsUpIcon";
import ThumbsDownIcon from "./ThumbsDownIcon";
var CloseButton = withIconButton(CloseIcon, "Close");
var MinimizeButton = withIconButton(MinimizeIcon, "Minimize");
var ThumbsUpButton = withIconButton(ThumbsUpIcon, "Thumbs Up");
var ThumbsDownButton = withIconButton(ThumbsDownIcon, "Thumbs Down");
export { CloseButton, MinimizeButton, ThumbsUpButton, ThumbsDownButton, BubbleIcon, CloseIcon, MinimizeIcon, PersonIcon, RobotIcon, HourGlassIcon, ThumbsUpIcon, ThumbsDownIcon, };
